import { IResourceChartRecord } from '@/dto/operationalPlanSummary';
import { OperationalDayName } from './OperationalDayName';

export class ResourceRecord {

    public static fromDto(dto: IResourceChartRecord): ResourceRecord {

        if (!dto) { throw new Error('dto is not set'); }

        const operDayName = OperationalDayName.fromDto(dto.operDayName);
        const result = new ResourceRecord(operDayName, dto.availableCount, dto.usedCount, dto.resourceType);

        return result;
    }

    public readonly operDayName: OperationalDayName;
    public readonly availableCount: number;
    public readonly usedCount: number;
    public readonly resourceType?: string;

    constructor(operDayName: OperationalDayName, availableCount: number, usedCount: number, resourceType?: string) {
        this.operDayName = operDayName;
        this.availableCount = availableCount;
        this.usedCount = usedCount;
        this.resourceType = resourceType;
    }

}
